import { LpLogosSection } from '@/features/landing-page/v3/sections/lp-logos-section'
import { LpStatementSection } from '@/features/landing-page/v3/sections/lp-statement-section'
import { LpCampaignsSection } from '@/features/landing-page/v3/sections/lp-campaigns-section'
import { LpChannelsSection } from '@/features/landing-page/v3/sections/lp-channels-section'
import { LpProductStepsSection } from '@/features/landing-page/v3/sections/lp-product-steps-section'
import { LpVisionSection } from '@/features/landing-page/v3/sections/lp-vision-section'
import { LpMagicSection } from '@/features/landing-page/v3/sections/lp-magic-section'
import { LpCaseStudiesSection } from '@/features/landing-page/v3/sections/lp-case-studies-section'
import { LpTestimonialsSection } from '@/features/landing-page/v3/sections/lp-testimonials-section'

/**
 * The lp-v3 home page sections rendered below the hero, in order. Grows as each section is migrated
 * from the old design.
 */
export function LpHomeSections() {
    return (
        <>
            <LpLogosSection />
            <LpVisionSection />
            <LpProductStepsSection />
            <LpChannelsSection />
            <LpMagicSection />
            <LpStatementSection />
            <LpTestimonialsSection />
            <LpCaseStudiesSection />
            <LpCampaignsSection />
        </>
    )
}
